/**
 * Plataforma Conecta — identidade e mapa de módulos (P0/P1).
 * @see docs/CONECTA-AGRADA/architecture/conecta-plataforma.md
 */

export const CONECTA_PLATFORM = {
  id: 'conecta',
  name: 'Conecta',
  legalName: 'Agrada Digital',
  idpName: 'Conecta ID',
  description: 'Plataforma operacional Agrada Digital',
  pwaShortName: 'Conecta',
} as const

export type ConectaModuleId =
  | 'comercial'
  | 'financeiro'
  | 'cs'
  | 'operacoes'
  | 'portal_pj'
  | 'admin'

export type ConectaModuleDef = {
  id: ConectaModuleId
  /** Nome de produto */
  label: string
  /** Rótulo do menu lateral (maiúsculas) */
  navLabel: string
  description: string
}

export const CONECTA_MODULES: Record<ConectaModuleId, ConectaModuleDef> = {
  comercial: {
    id: 'comercial',
    label: 'Comercial',
    navLabel: 'COMERCIAL',
    description: 'Pipeline, BDR, negociações e cadastros comerciais',
  },
  financeiro: {
    id: 'financeiro',
    label: 'Financeiro',
    navLabel: 'FINANCEIRO',
    description: 'Solicitações, clientes e prestadores PJ',
  },
  cs: {
    id: 'cs',
    label: 'Sucesso do Cliente',
    navLabel: 'SUCESSO DO CLIENTE',
    description: 'Carteira, retenção e painel CS',
  },
  operacoes: {
    id: 'operacoes',
    label: 'Operações',
    navLabel: 'OPERAÇÕES',
    description: 'Portal gestores e operação de equipe',
  },
  portal_pj: {
    id: 'portal_pj',
    label: 'Portal',
    navLabel: 'PORTAL',
    description: 'Portal do prestador e acesso compartilhado',
  },
  admin: {
    id: 'admin',
    label: 'Admin',
    navLabel: 'ADMIN',
    description: 'Configuração e segurança da plataforma',
  },
}

/** Prefixos de rota → módulo (mais específico primeiro). */
const MODULE_PATH_RULES: Array<{ prefix: string; module: ConectaModuleId }> = [
  { prefix: '/portal', module: 'portal_pj' },
  { prefix: '/gestores', module: 'operacoes' },
  { prefix: '/cs', module: 'cs' },
  { prefix: '/financeiro', module: 'financeiro' },
  { prefix: '/clientes', module: 'financeiro' },
  { prefix: '/pj-agrada', module: 'financeiro' },
  { prefix: '/configuracao', module: 'admin' },
  { prefix: '/security', module: 'admin' },
  { prefix: '/dashboard', module: 'comercial' },
  { prefix: '/bdr-panel', module: 'comercial' },
  { prefix: '/deals', module: 'comercial' },
  { prefix: '/tarefas', module: 'comercial' },
  { prefix: '/closer-leads', module: 'comercial' },
  { prefix: '/empresas', module: 'comercial' },
  { prefix: '/partners', module: 'comercial' },
  { prefix: '/rocket-search', module: 'comercial' },
  { prefix: '/proposal-studio', module: 'comercial' },
]

export function resolveConectaModule(pathname: string): ConectaModuleId | null {
  const path = pathname.split('?')[0] || '/'
  for (const rule of MODULE_PATH_RULES) {
    if (path === rule.prefix || path.startsWith(`${rule.prefix}/`)) {
      return rule.module
    }
  }
  return null
}

export function getConectaModuleNavLabel(moduleId: ConectaModuleId): string {
  return CONECTA_MODULES[moduleId].navLabel
}
